import { TeamService } from '@modules/team/team-service';
import Errors from '@shared/error/errors';
import ManageModel from '@shared/manage/manage-model';

export default {
  namespaced: true,

  state: {
    rows: [],
    count: 0,
    loading: false,
  },

  getters: {
    loading: (state) => state.loading,

    rows: (state) => state.rows || [],

    count: (state) => state.count,

  },

  mutations: {
    RESETED(state) {
      state.rows = [];
      state.count = 0;
      state.loading = false;
    },

    FETCH_STARTED(state) {
      state.loading = true;
    },

    FETCH_SUCCESS(state, payload) {
      state.loading = false;
      state.rows = payload.rows;
      state.count = payload.count;
    },

    FETCH_ERROR(state) {
      state.loading = false;
      state.rows = [];
      state.count = 0;
    },
  },

  actions: {
    async doReset({ commit, dispatch }) {
      commit('RESETED');
      return dispatch('doFetch');
    },

    async doFetch(
      { commit, getters },
      { filter, keepPagination, manage } = {},
    ) {
      try {
        commit('FETCH_STARTED', { filter, keepPagination });

        const manageInput = new ManageModel(manage).getManageModel()

        const response = await TeamService.listTransfer(
          filter,
          getters.orderBy,
          getters.limit,
          getters.offset,
          manageInput
        );

        commit('FETCH_SUCCESS', {
          rows: response.rows,
          count: response.count,
        });
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      }
    },
  },
};
